import Link from 'next/link';
import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.section`
  display: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 15px;
    background-color: ${({ theme }) => theme.palette.primary.background};
    border-radius: 0 0 21px 21px;
  }
`;

export const UserRow = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr 30px;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
`;

export const UserInfo = styled.div`
  min-width: 0;
`;

export const Avatar = styled.div<{ $avatarUrl?: string }>`
  width: 40px;
  height: 40px;
  background-image: ${({ $avatarUrl }) =>
    $avatarUrl ? `url(${$avatarUrl})` : 'url(/images/profile-square.svg)'};
  background-position: center;
  background-size: cover;
`;

export const UserName = styled(Typography.Body).attrs({ $variant: '5' })`
  font-weight: 500;
  margin-bottom: 3px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const UserMeta = styled(Typography.Body).attrs({ $variant: '4' })`
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const UserId = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const Phone = styled.span`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const MenuButton = styled.button`
  padding: 4px;
  width: 30px;
  height: 30px;
  border: none;
  color: ${({ theme }) => theme.palette.primary.labels};
  background-color: transparent;
  cursor: pointer;
`;

export const MenuButtonIconOutline = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border: 1px solid ${({ theme }) => theme.palette.primary.labels};
  border-radius: 50%;
`;

export const Balance = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 15px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
`;

export const BalanceLabel = styled(Typography.Body).attrs({ $variant: '4' })`
  margin-bottom: 4px;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const BalanceValue = styled(Typography.Header).attrs({ $variant: '2' })`
  font-size: 18px;
  font-weight: 500;
`;

export const BalanceButton = styled(Button)`
  min-width: 130px;
  height: 40px;
`;

export const QuickNav = styled.nav`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 5px 0;
`;

export const QuickNavItem = styled(Link)`
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const QuickNavIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  border-radius: 50%;
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.05);
`;

export const QuickNavTitle = styled(Typography.Body).attrs({ $variant: '3' })`
  text-align: center;
`;

export const MenuContent = styled.div`
  width: 100%;
`;

export const MenuGrid = styled.nav`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding: 10px 15px;
`;

export const MenuItem = styled(Link)<{ $isActive: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px 15px;
  border-radius: 20px;
  color: ${({ theme }) => theme.palette.primary.labels};
  background-color: ${({ theme }) => theme.palette.secondary.background};

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: ${({ theme }) => theme.palette.system.deepBlue};
    `}
`;

export const MenuItemTitle = styled(Typography.Body).attrs({ $variant: '4' })`
  color: currentColor;
`;

export const MenuDivider = styled.div`
  height: 1px;
  margin: 15px;
  background-color: ${({ theme }) => theme.palette.primary.border};
`;

export const MenuLogoutButton = styled(Button)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  gap: 10px;
  width: 100%;
  border: none;
  background-color: transparent;
  color: ${({ theme }) => theme.palette.primary.labels};
`;
